import React, { Component } from "react";

import { DKLabel,DKButton } from "deskera-ui-library";
import ic_arrow_back from "../../../assets/icons/ic_arrow_back.svg";
import RouteManager from "../../../managers/RouteManager";
import LeftPanel from "./LeftPanel";
import ActivityPanel from "./ActivityPanel";
import RightPanel from "./RightPanel";

class DealsUI extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dealDetails: {},
      showRightPanel:false
    };
    this.dealId = this.props.match.params.id;
  }
  componentDidMount() {
    RouteManager.setPresenter(this);
  }
  getDeal = (dealDetails) => {
    this.setState(
      {
      dealDetails: dealDetails
      }, () => {
        this.setState({
          showRightPanel:true
        })
    }
    )
  }
  render() {
    return (
      <div className="parent-width parent-height">
        <DKButton className="d-inline-flex pl-0 pt-0" title="Back" icon={ic_arrow_back} onClick={()=>RouteManager.goBack()}/>
        <DKLabel className="fs-l fw-m" text="Candidate details"></DKLabel>
        <div className="row mt-m align-items-start parent-height">
          {this.getLeftPanel()}
          {this.getActivityPanel()}
          {this.state.showRightPanel && this.getRightPanel()}
        </div>
      </div>
    );
  }

  getLeftPanel() {
    return <LeftPanel dealId={this.dealId} getDeal={(dealDetails)=>this.getDeal(dealDetails)}/>;
  }

  getActivityPanel() {
    return <ActivityPanel module="DEAL" id={this.dealId}/>;
  }

  getRightPanel() {
    return <RightPanel dealId={this.dealId} dealDetails={this.state.dealDetails}/>;
  }

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
}

export default DealsUI;
